export default __webpack_public_path__ + "static/media/logo.e03974f8.svg";